import React from 'react';
import ReactDOM from 'react-dom';

import HomePage from 'Siteadmin/pages/HomePage';

ReactDOM.render(
    <React.StrictMode>
        <HomePage />
    </React.StrictMode>,
    document.getElementById('mets-react-siteadmin')
);
